import React, { useState } from 'react';
import { useTypedSelector } from '../../../../../../../../store/reducers/use-typed-selector';
import { HomepageHeader } from '../../../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../../../general-ui/icon';
import Switch from '../../../../../../../general-ui/switch/switch';
import { Tooltip } from '../../../../../../../general-ui/tooltip/tooltip';

interface IHomepageHeaderAdvancedLayoutProps {
	module: HomepageHeader;
	onUpdate?: (data: { sticky: boolean; signInBtn: boolean; }) => void;
}

const HomepageHeaderAdvancedLayout: React.FC<IHomepageHeaderAdvancedLayoutProps> = ({ onUpdate }) => {
	const workingEvent = useTypedSelector(event => event.CreateEventReducer.workingEvent);
	const isEmailConfirmationEnabled = !!workingEvent?.registration_settings?.sendEmailConfirmation;
	const [sticky, setSticky] = useState(!!workingEvent?.homepage?.header.is_sticky);
	const [signInBtn, setSignInBtn] = useState(!!workingEvent?.homepage?.header?.sign_in_button);

	const handleStickyHeaderClick = (_: unknown, on: boolean) => {
		setSticky(on);
		onUpdate?.({ sticky: on, signInBtn });
	};

	const handleSignInBtnClick = (_: unknown, on: boolean) => {
		setSignInBtn(on);
		onUpdate?.({ sticky, signInBtn: on });
	};

	return (
		<>
			<div className="panel-block">
				<div className="settings-row flex-space-between">
					<span className="flex-center gap-4 margin-r-16">
						<h6 className="H6 margin-0">Sticky header</h6>
						<Tooltip tooltip="Keep header fixed to the top of the page when scrolling." position={"top-right"}>
							<Icon
								name={ICONS.INFO_OUTLINE}
								color={COLORS.CYAN}
								size={14}
							/>
						</Tooltip>
					</span>

					<Switch
						value={'sticky header'}
						on={sticky}
						onClick={handleStickyHeaderClick}
					/>
				</div>
			</div>
			<div className="panel-block">
				<div className="settings-row flex-space-between">
					<span className="flex-center gap-4  margin-r-16">
						<h6 className="H6 margin-0">"Sign In" Button</h6>
						<Tooltip tooltip="Add a Sign In button for easy returning user when they land on your landing page. Send email confirmation must be on." position={"top-right"}>
							<Icon
								name={ICONS.INFO_OUTLINE}
								color={COLORS.CYAN}
								size={14}
							/>
						</Tooltip>
					</span>

					<Switch
						value={'sign-in-btn'}
						on={signInBtn}
						disabled={!signInBtn && !isEmailConfirmationEnabled} // Keep this enabled in the case that an admin has toggled this on before disabling email confirmation.
						onClick={handleSignInBtnClick}
					/>
				</div>
			</div>
		</>
	);
};

export default HomepageHeaderAdvancedLayout;
